import { NavTabPartialProps } from "@/components/custom/tabs/nav-tabs";
import { ResourcesTabs } from "./-resources-tabs";
import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

export const Layout = React.forwardRef<
  HTMLDivElement,
  {
    children?: React.ReactNode;
    tabs?: NavTabPartialProps;
    scroll?: boolean;
  }
>(({ children, tabs, scroll = true }, ref) => {
  const Wrap = React.useCallback(
    ({ children }) =>
      scroll ? (
        <ScrollArea
          viewport={{ className: cn("pt-3 h-lg:pt-4") }}
          className={cn("h-full", "-mr-4 pr-4")}
        >
          {children}
        </ScrollArea>
      ) : (
        children
      ),
    [scroll],
  );
  return (
    <ResourcesTabs padding={!scroll} {...tabs}>
      <Wrap>{children}</Wrap>
    </ResourcesTabs>
  );
});
